import Rule, {IRuleObj} from "./Rule"
import {IRuleInputOption} from "../../../components/rule/AsyncRuleInputSelection"
import ru from "date-fns/locale/ru"


export default class NameTemplateRule extends Rule {
    static output_type = "ozonOutputNameTemplate"
    private _sku_part_rule!: IRuleObj

    constructor(rule: IRuleObj) {
        super(rule)
        if (rule.children_rules) {
            const is_just_name = rule.saved_rule?.input_name === "$name"
            for (const childRule of rule.children_rules) {
                if (childRule.type === "ozonOutputPartSku") {
                    this._sku_part_rule = childRule
                    if (is_just_name) {
                        continue
                    }
                }
                const rule = new Rule(childRule)
                this._child_rules.push(rule)
            }
        }
    }

    setRuleInput({input_type, input_name, input_title}: IRuleInputOption): void {
        super.setRuleInput({input_type, input_name, input_title})
        if (input_name === "$name") {
            this.hideSkuInput()
        } else {
            this.hideSkuInput()
            this.appendSkuInput()
        }
        // return promise
    }

    appendSkuInput() {
        console.log(this._sku_part_rule)
        this._child_rules.push(new Rule(this._sku_part_rule))
    }

    hideSkuInput() {
        this._child_rules = this._child_rules.filter(rule => rule.type !== "ozonOutputPartSku")
    }

    // private _child_rules: Rule[] = []
    //
    // get child_rules(): Rule[] {
    //     return this._child_rules
    // }


}